import React from "react";
import { useTranslation } from "react-i18next";
import SFButtonGroup from "../../buttonGroup";
import getStyled from "../../../hooks/getStyled";

const { styled } = getStyled();

const SFButtonGroupStyled = styled(SFButtonGroup)(({ theme }) => ({
  "& .MuiButton-root": {
    fontSize: 10,
    padding: "5.5px",
  },
}));

const NotToggle = (props) => {
  const { t } = useTranslation();
  return (
    <SFButtonGroupStyled
      indicateSelected
      variant="switch"
      buttons={[
        {
          label: t("components.queryBuilder.isLabel"),
          onClick: () => props.handleOnChange(false),
        },
        {
          label: t("components.queryBuilder.isNotLabel"),
          onClick: () => props.handleOnChange(true),
          selected: props.checked,
        },
      ]}
    />
  );
};

export default NotToggle;
